@if(entity)
{
<h2>{{entity.orderNumber}}</h2>
<h3> Status: {{entity.status_Name}}</h3>

@if(requiresShippingMethod){
<h4> {{entity.shippingMethod_Name}}</h4>
}

@if(isAdmin && entity.projectOrReturnOrder != null){
<h4 style="white-space:pre-wrap;"><a target="_blank" href="{{entity.projectOrReturnOrder.projectLink}}">{{entity.projectOrReturnOrder.projectID}}</a></h4>
<h4 style="white-space:pre-wrap;"><a target="_blank" href="{{entity.projectOrReturnOrder.returnOrderLink}}">{{entity.projectOrReturnOrder.returnOrder}}</a></h4>
}

<p style="font-size: 12px; color: lightgray"> {{entity.whenCreated}} from Draft Orders by {{entity.whoCreated_Name}}</p>
}

<div class="box content">
  <app-detail-layout [name]="name"
                     [id]="id"
                     [apiController]="apiController"
                     [views]="views"
                     viewType="tab"
                     [toolbarItems]="toolbarItems"
                     [showSaveButton]="updateOrderPermission"
                     [showRemoveButton]="false"
                     [keyFieldName]="keyFieldName"
                     (entityLoaded)="entityLoaded()"
                     [(entity)]="entity"
                     [preSave]="true"
                     (save)="preSave($event)"
                     [breadCrumbPropertyNames]="breadCrumbPropertyNames">
  </app-detail-layout>
</div>

<kendo-stacklayout orientation="vertical" style="width:100%">
  <div class="gridsContainer">

    <div #orderSection>
      <form novalidate #orderForm="ngForm">
        @if(entity) {
        <kendo-grid #grid
                    id="ItemUniqueSearch_Grid"
                    [kendoGridBinding]="itemUniqnumList"
                    [data]="itemUniqnumList"
                    [sortable]="true"
                    [filterable]="false"
                    [resizable]="true"
                    [reorderable]="true"
                    [groupable]="false"
                    [pageSize]="100"
                    [selectable]="selectableSettings"
                    (cellClick)="onCellClicked($event)"
                    (dblclick)="onGridDoubleClicked($event)"
                    [pageable]="pagerSettings"
                    [skip]="state.skip || 0"
                    [sort]="state.sort || []"
                    style="height:100%; width: 100%">

          <kendo-grid-column field="uniqnum" title="Uniqnum" filter="text" [width]="70" [editable]="false"></kendo-grid-column>
          <kendo-grid-column field="title" title="Title" filter="text" [width]="70" [editable]="false"></kendo-grid-column>
          <kendo-grid-column field="serial" title="Serial" filter="text" [width]="70" [editable]="false"></kendo-grid-column>
          <kendo-grid-column field="addon" title="Add On(s)" filter="text" [width]="70" [editable]="false"></kendo-grid-column>
          <div>
          </div>
        </kendo-grid>
        <kendo-contextmenu #gridMenu
                           [kendoMenuHierarchyBinding]="contextMenuItems"
                           [textField]="'title'"
                           childrenField="items"
                           svgIconField="iconClass"
                           separatorField="separator"
                           (select)="onContextMenuSelect($event)">
        </kendo-contextmenu>
        }
      </form>
    </div>
  </div>

</kendo-stacklayout>

<kendo-stacklayout orientation="vertical" style="width:100%">

  @if (openCancelDialog) {
  <kendo-dialog title="Cancel Order" [animation]="true" (close)="closeCancelConfirmDialog()">
    <p>Are you sure you want to CANCEL this order?</p>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeCancelConfirmDialog()" [svgIcon]="dialogNo">
        No
      </button>
      @if (dialogIcon) {
      <button kendoButton themeColor="tertiary" (click)="cancelOrder()" [svgIcon]="dialogYes">
        Yes
      </button>
      }
      @else {
      <button kendoButton themeColor="tertiary" (click)="cancelOrder()">
        Yes
      </button>
      }
    </kendo-dialog-actions>
  </kendo-dialog>
  }

  @if (openShipDialog) {
  <kendo-dialog title="Ship Order" [animation]="true" (close)="closeShipConfirmDialog()">
    <p>Are you sure you want to mark this order SHIPPED?</p>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeShipConfirmDialog()" [svgIcon]="dialogNo">
        No
      </button>
      @if (dialogIcon) {
      <button kendoButton themeColor="tertiary" (click)="shipOrder()" [svgIcon]="dialogYes">
        Yes
      </button>
      }
      @else {
      <button kendoButton themeColor="tertiary" (click)="shipOrder()">
        Yes
      </button>
      }
    </kendo-dialog-actions>
  </kendo-dialog>
  }
</kendo-stacklayout>
